import React from 'react';
import { BackArrow } from 'src/assets/images';
import { Colors } from 'src/common';
import type { StepperProps } from 'src/components/Stepper/Stepper';

import styled from 'styled-components';

const HeaderContainer = styled.header`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 1.5rem;

  > p {
    margin: 0;
    font-size: 0.75rem;
    color: ${Colors.Grey100};
  }

  > em {
    font-size: 1rem;
    font-weight: 500;
    font-style: normal;
    color: ${Colors.WhiteGrey};
  }
`;

const Container = styled.div`
  display: flex;
`;

const ProgressLine = styled.hr<{ $value: number }>`
  height: 2px;
  margin: 0;
  border: none;
  margin-bottom: 1.5rem;

  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;

  ${({ $value }) => `
		width: ${$value}%;
		background-color: ${Colors.LightTeal};
	`}
`;

export const Progress: React.FC<StepperProps> = ({
  steps,
  onBackButton,
  hideBackButton,
  currentStep,
  currentSubStep = 0,
}) => {
  const progression = React.useMemo((): number => {
    const numberOfSteps = steps.reduce((total, step) => total + step.substeps, 0);

    const stepsCompleted = steps.reduce((total, step, index) => {
      if (index === currentStep) {
        return total + currentSubStep + 1;
      }

      if (index > currentStep) {
        return total;
      }

      return total + step.substeps;
    }, 0);

    return Math.round((stepsCompleted / numberOfSteps) * 100);
  }, [steps, currentStep, currentSubStep]);

  const isLastStep = currentStep + 1 < steps.length;
  const nextStep = isLastStep ? steps[currentStep + 1] : { label: 'Done!' };
  const stepLabel = isLastStep ? `Next: ${nextStep.label}` : nextStep.label;

  return (
    <div>
      <Container>
        {!hideBackButton && <img src={BackArrow} onClick={onBackButton} alt="back-arrow" />}
        <HeaderContainer>
          <p>
            Step {currentStep + 1} of {steps.length}
          </p>
          <em>{steps.at(currentStep)?.label || `Step ${currentStep + 1}`}</em>
          <p>{stepLabel}</p>
        </HeaderContainer>
      </Container>
      <ProgressLine $value={progression} />
    </div>
  );
};
